import {
  RoomApplicationEntity,
  ApplicationsResponse,
  InternalUserEntity,
  ApplicationStatus,
} from 'src/types'

type ToEntitiesInput = {
  response: ApplicationsResponse
  internalUsers: InternalUserEntity[]
}

export const ApplicationTranslator = {
  toEntities: (input: ToEntitiesInput): RoomApplicationEntity[] => {
    const { response, internalUsers } = input

    return response.applications.map(application => {
      // 申請の作成者
      const creator = internalUsers.find(user => user.id === application.creatorId)

      const reviewStep = application.applicationSteps.find(step => step.status === 'reviewing')
      const reviewers = internalUsers.filter(user =>
        reviewStep?.applicationStepConfirmations.map(c => c.confirmerId).includes(user.id)
      )

      return {
        id: `${application.id}`,
        workflowId: `${application.workflowId}`,
        title: application.title,
        creator,
        creatorId: application.creatorId,
        status: application.status as ApplicationStatus,
        comment: application.comment ?? undefined,
        steps: application.applicationSteps.map(step => {
          return {
            id: `${step.id}`,
            stepNumber: step.stepNumber,
            dueAt: new Date(step.dueDate),
            status: step.status as ApplicationStatus,
            multiApproverCondition: step.multiApproverCondition
              ? (step.multiApproverCondition as 'AND' | 'OR')
              : undefined,
            confirmations: step.applicationStepConfirmations.map(confirmation => {
              const verifier = internalUsers.find(
                user => user.id === confirmation.confirmerId
              ) as InternalUserEntity

              return {
                id: `${confirmation.id}`,
                verifier,
                verifierId: confirmation.confirmerId,
                status: confirmation.status as ApplicationStatus,
                comment: confirmation.comment ?? undefined,
                isProxy: confirmation.isProxy,
              }
            }),
          }
        }),
        roomIds: application.roomIds.map(id => `${id}`),
        canceledRoomIds: application.canceledRoomIds.map(id => `${id}`),
        notifiedUserEmails: application.notifiedUserEmails,
        reviewers,
        createdAt: new Date(application.createdAt),
      }
    })
  },
}
